import { render } from "./AddTax.vue?vue&type=template&id=647d1bb1&ts=true"
import script from "./AddTax.vue?vue&type=script&lang=ts"
export * from "./AddTax.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__